import {Container, GridCellSummary, StorableSummary} from 'constants/SampleConstants';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import GridCellKey from 'test/lib/cypress/shared/GridCellKey';

export const MODAL_KEYS = {
  MATRIX_INPUT: 'MATRIX_INPUT',
  CHANGE_SUMMARY: 'CHANGE_SUMMARY',
  SELECT_PARENT: 'SELECT_PARENT',
};

export const MODAL_ORDER = [MODAL_KEYS.MATRIX_INPUT, MODAL_KEYS.CHANGE_SUMMARY, MODAL_KEYS.SELECT_PARENT];

export interface Change {
  container: Container;
  previous: {
    parentStorable: StorableSummary | null;
    gridCell?: GridCellSummary;
  } | null;
}

export interface ChangeStats {
  create: number;
  moveIn: number;
  moveOut: number;
  reposition: number;
  noChange: number;
}

enum MoveOutcome {
  CREATE = 'create',
  MOVE_IN = 'moveIn',
  MOVE_OUT = 'moveOut',
  REPOSITION = 'reposition',
  NO_CHANGE = 'noChange',
}

export const MOVE_OUTCOMES: {
  [k in MoveOutcome]: {name: string; gridCellClassName: string; dataTestAttrs: Pick<DataTestAttrs, 'key'>};
} = {
  [MoveOutcome.CREATE]: {
    name: 'Create',
    gridCellClassName: 'gridCell-inner--createdContainer',
    dataTestAttrs: {key: GridCellKey.CREATE},
  },
  [MoveOutcome.MOVE_IN]: {
    name: 'Move in',
    gridCellClassName: 'gridCell-inner--moveInContainer',
    dataTestAttrs: {key: GridCellKey.MOVE_IN},
  },
  [MoveOutcome.MOVE_OUT]: {
    name: 'Move out',
    gridCellClassName: 'gridCell-inner--moveOutContainer',
    dataTestAttrs: {key: GridCellKey.CREATE_MOVE_OUT},
  },
  [MoveOutcome.REPOSITION]: {
    name: 'Reposition',
    gridCellClassName: 'gridCell-inner--repositionContainer',
    dataTestAttrs: {key: GridCellKey.REPOSITION},
  },
  [MoveOutcome.NO_CHANGE]: {
    name: 'No change',
    gridCellClassName: 'gridCell-inner--noChangeContainer',
    dataTestAttrs: {key: GridCellKey.NO_CHANGE},
  },
};

export const MOVE_OUTCOMES_ORDER: Array<MoveOutcome> = [
  MoveOutcome.CREATE,
  MoveOutcome.MOVE_IN,
  MoveOutcome.MOVE_OUT,
  MoveOutcome.REPOSITION,
  MoveOutcome.NO_CHANGE,
];
